export default __webpack_public_path__ + "static/media/515.8cffe634.gif";